import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Icons } from "../../assest/icons";
import { toast } from 'react-toastify';
import {
  getAppointmentNotificationEmails,
  setAppointmentNotificationEmails,
  getAISummaryTemplate,
  setAISummaryTemplate,
  DEFAULT_AI_SUMMARY_TEMPLATE,
  ROLE_LABELS,
  createAdminLog,
} from '../../services/firestore';
import { canAccessSettings, getAdminRole, canManageAdminUsers } from '../../utils/roleHelper';

function Header() {
  const usernameTxt = JSON.parse(localStorage.getItem('UserProfileAdmin'));
  const [UserName] = useState(usernameTxt?.fullName || 'Admin');
  const adminId = localStorage.getItem('UserIdAdmin');
  let navigate = useNavigate();

  // Notification Emails modal state
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emails, setEmails] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [loadingEmails, setLoadingEmails] = useState(false);
  const [savingEmails, setSavingEmails] = useState(false);

  // Consultant Summary Template modal state
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [template, setTemplate] = useState('');
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [savingTemplate, setSavingTemplate] = useState(false);

  const handleSettings = () => {
    if (canManageAdminUsers()) {
      navigate("/admin/adminusersinfo", { state: usernameTxt?.user_id });
    } else {
      navigate("/admin/myprofile", { state: usernameTxt?.user_id });
    }
  };
  const handleLogout = () => {
    // HIPAA: Audit log before clearing
    createAdminLog({
      action: 'admin_logout',
      admin_id: adminId || 'unknown',
      admin_email: usernameTxt?.email || 'unknown',
    }).catch(() => {});
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = 'https://admin.aigicare.com/';
  };
  const handleforgotpwd = () => {
    navigate("/admin/changepassword");
  };

  // ---- Notification Emails ----
  const openEmailModal = async () => {
    setShowEmailModal(true);
    setLoadingEmails(true);
    const list = await getAppointmentNotificationEmails();
    setEmails(list);
    setLoadingEmails(false);
  };
  const handleAddEmail = () => {
    const trimmed = newEmail.trim().toLowerCase();
    if (!trimmed) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      toast.error('Invalid email address');
      return;
    }
    if (emails.includes(trimmed)) {
      toast.error('Email already added');
      return;
    }
    setEmails([...emails, trimmed]);
    setNewEmail('');
  };
  const handleSaveEmails = async () => {
    setSavingEmails(true);
    try {
      await setAppointmentNotificationEmails(emails, {
        adminId,
        adminEmail: usernameTxt?.email || '',
        adminName: usernameTxt?.fullName || '',
      });
      toast.success('Notification emails saved!');
      setShowEmailModal(false);
    } catch (e) {
      toast.error('Failed to save. Please try again.');
    }
    setSavingEmails(false);
  };

  // ---- Consultant Summary Template ----
  const openTemplateModal = async () => {
    setShowTemplateModal(true);
    setLoadingTemplate(true);
    const saved = await getAISummaryTemplate();
    setTemplate(saved || DEFAULT_AI_SUMMARY_TEMPLATE);
    setLoadingTemplate(false);
  };
  const handleSaveTemplate = async () => {
    if (!template.trim()) {
      toast.error('Template cannot be empty');
      return;
    }
    setSavingTemplate(true);
    try {
      await setAISummaryTemplate(template);
      toast.success('Template saved!');
      setShowTemplateModal(false);
    } catch (e) {
      toast.error('Failed to save template.');
    }
    setSavingTemplate(false);
  };

  const overlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.45)', zIndex: 9999,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  };
  const modalStyle = {
    background: '#fff', borderRadius: '14px', padding: '28px',
    width: '480px', maxWidth: '95vw', maxHeight: '85vh',
    overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
  };

  return (
    <div>
      <div className="containerDiv whiteBg headerDivBox adminHeader">
        <ul className="rightDiv d-inline-block sidenavList" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <li className="listOpt accordion">
            <span className="profileImg">
              <b>{UserName.split(' ').map(word => word.charAt(0).toUpperCase()).join('')}</b>
            </span>
            <span style={{ fontSize: '12px', color: '#555', fontWeight: '500', whiteSpace: 'nowrap' }}>
              {ROLE_LABELS[getAdminRole()] || 'Admin'}
            </span>
            <span className="ddownDiv form-group dropdown-toggle toggle-select-result"
              role="button" data-bs-toggle="dropdown"></span>
            <div id="regularCollapseDdown" className="accordion-collapse collapse dropdown-menu">
              <div className="accordion-body p-0">
                <ul className="accordion mt-0" id="myAccordion1">
                  <li><b><img src={Icons[0].userImg} className="logoImg" alt="" /></b> <a onClick={() => handleSettings()}>My Profile</a></li>
                  {canAccessSettings() && (
                    <li><b><img src={Icons[0].mailImg} className="logoImg" alt="" style={{ height: '20px' }} /></b> <a onClick={openEmailModal} style={{ cursor: 'pointer' }}>Notification Emails</a></li>
                  )}
                  {canAccessSettings() && (
                    <li><b><img src={Icons[0].mailImg} className="logoImg" alt="" style={{ height: '20px' }} /></b> <a onClick={openTemplateModal} style={{ cursor: 'pointer' }}>Consultant Summary Template</a></li>
                  )}
                  <li><b><img src={Icons[0].lockedImg} alt="" /></b> <a onClick={() => handleforgotpwd()}>Change Password</a></li>
                  <hr />
                  <li><b><img src={Icons[0].logoutIcon} alt="" /></b> <a onClick={() => handleLogout()}>Logout</a></li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>

      {/* Notification Emails Modal */}
      {showEmailModal && (
        <div style={overlayStyle} onClick={() => setShowEmailModal(false)}>
          <div style={modalStyle} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>Notification Emails</h3>
              <button onClick={() => setShowEmailModal(false)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>×</button>
            </div>
            <p style={{ color: '#666', fontSize: '13px', marginBottom: '16px' }}>
              These emails will receive a notification whenever a new appointment is submitted.
            </p>
            {loadingEmails ? (
              <p style={{ color: '#999' }}>Loading...</p>
            ) : (
              <>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                  <input
                    type="email"
                    placeholder="Enter email address"
                    value={newEmail}
                    onChange={e => setNewEmail(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && handleAddEmail()}
                    style={{ flex: 1, padding: '9px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none' }}
                  />
                  <button onClick={handleAddEmail} style={{ padding: '9px 18px', whiteSpace: 'nowrap', background: '#024C9C', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', height: '40px' }}>+ Add</button>
                </div>
                {emails.length === 0 ? (
                  <p style={{ color: '#aaa', fontSize: '13px', fontStyle: 'italic', marginBottom: '16px' }}>No emails added yet.</p>
                ) : (
                  <ul style={{ listStyle: 'none', padding: 0, marginBottom: '16px' }}>
                    {emails.map((email, i) => (
                      <li key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: '#f8f9fa', borderRadius: '8px', marginBottom: '6px', fontSize: '14px', border: '1px solid #eee' }}>
                        <span>{email}</span>
                        <button onClick={() => setEmails(emails.filter(e => e !== email))} style={{ background: 'none', border: 'none', color: '#dc3545', fontSize: '20px', cursor: 'pointer', lineHeight: 1 }}>×</button>
                      </li>
                    ))}
                  </ul>
                )}
                <button onClick={handleSaveEmails} disabled={savingEmails} style={{ padding: '10px 24px', background: '#024C9C', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: savingEmails ? 'not-allowed' : 'pointer', opacity: savingEmails ? 0.7 : 1 }}>
                  {savingEmails ? 'Saving...' : 'Save'}
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Consultant Summary Template Modal */}
      {showTemplateModal && (
        <div style={overlayStyle} onClick={() => setShowTemplateModal(false)}>
          <div style={{ ...modalStyle, width: '640px' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>Consultant Summary Template</h3>
              <button onClick={() => setShowTemplateModal(false)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>×</button>
            </div>
            <p style={{ color: '#666', fontSize: '13px', marginBottom: '16px' }}>
              Define the sections used when generating AI clinical summaries for consultants.
            </p>
            {loadingTemplate ? (
              <p style={{ color: '#999' }}>Loading...</p>
            ) : (
              <>
                <textarea
                  value={template}
                  onChange={e => setTemplate(e.target.value)}
                  rows={18}
                  style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', fontFamily: 'monospace', lineHeight: '1.6', outline: 'none', resize: 'vertical', marginBottom: '14px' }}
                />
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button onClick={handleSaveTemplate} disabled={savingTemplate} style={{ padding: '10px 24px', background: '#024C9C', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: savingTemplate ? 'not-allowed' : 'pointer', opacity: savingTemplate ? 0.7 : 1 }}>
                    {savingTemplate ? 'Saving...' : 'Save Template'}
                  </button>
                  <button onClick={() => setTemplate(DEFAULT_AI_SUMMARY_TEMPLATE)} style={{ padding: '10px 18px', border: '1px solid #ccc', borderRadius: '8px', background: '#fff', color: '#555', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                    Reset to Default
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
